/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type InfiniteScrollMessages_Viewer = {
    readonly " $fragmentRefs": FragmentRefs<"ChatMessage_Viewer">;
    readonly " $refType": "InfiniteScrollMessages_Viewer";
};
export type InfiniteScrollMessages_Viewer$data = InfiniteScrollMessages_Viewer;
export type InfiniteScrollMessages_Viewer$key = {
    readonly " $data"?: InfiniteScrollMessages_Viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"InfiniteScrollMessages_Viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InfiniteScrollMessages_Viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChatMessage_Viewer"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '245d004126eb29af0ddd797a804e8729';
export default node;
